import React, { useState, useEffect, useMemo } from 'react'
import Header from '../users/Header'
import NavHeader from '../users/NavHeader'
import { UserAuth } from '../../context/AuthContext'
import { BiWallet } from 'react-icons/bi'
import { NavLink } from 'react-router-dom';
import { MdOutlineLibraryAdd } from 'react-icons/md';
import Footer from './../users/Footer'
import ReactPaginate from 'react-paginate';
import SearchField from "react-search-field";
import { FaEdit, FaTrash } from 'react-icons/fa';

const Manage = () => {

    const { user, lihatWallet, deleteWallet } = UserAuth();
    const uname = user.displayName;


    const [error, setError] = useState('');
    const [loading, setLoading] = useState();

    const [showNotification, setShowNotification] = useState(false);
    const [timeoutId, setTimeoutId] = useState(null);
    useEffect(() => {
        return () => {
            clearTimeout(timeoutId);
        };
    }, [timeoutId]);

    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage] = useState(7);
    const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const result = await lihatWallet(uname);
                setData(result);
            } catch (error) {
                setShowNotification(true);
                setError(error);
            }
            setLoading(false);
        };

        fetchData();
        setTimeoutId(setTimeout(() => setShowNotification(false), 7000));
    }, [lihatWallet, uname]);

    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected);
    };

    const filteredData = useMemo(() => {
        return data.filter((item) => {
            return (
                item.address.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.chain.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.label.toLowerCase().includes(searchQuery.toLowerCase())
            );
        });
    }, [data, searchQuery]);

    const startIndex = filteredData.length > 0 ? currentPage * itemsPerPage + 1 : 0;
    const endIndex = Math.min(startIndex + itemsPerPage - 1, filteredData.length);
    const itemsToShow = filteredData.slice(startIndex - 1, endIndex);

    const [limit, setLimit] = useState(50);
    const [limitLabel, setLimitLabel] = useState(50);
    const [limitChain, setLimitChain] = useState(50);
    const [apakahPC, setApakahPC] = useState('');

    useEffect(() => {
        const handleResize = () => {
            const screenWidth = window.innerWidth;
            if (screenWidth < 768) {
                setLimit(25);
                setLimitLabel(17);
                setLimitChain(7);
            } else {
                setLimit(35);
                setApakahPC(true);
                setLimitLabel(5);
            }
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const hapusWallet = async (key) => {
        setLoading(true);
        try {
            const result = await deleteWallet(uname, key);
            if (result === true) {
                setData(data.filter(item => item.added !== key));
                setShowNotification(true);
                setError(`Wallet dihapus`);
            } else {
                throw new Error(result);
            }
        } catch (e) {
            setShowNotification(true);
            setError(e.message);
        }
        setLoading(false);
    };

    return (
        <div className="antialiased bg-primary md:block md:bg-indigo-50" style={{ backgroundImage: `url('/images/bg-body.png')` }} relative>
            <NavHeader />
            <div className="max-w-[600px] mx-auto min-h-screen bg-slate-100 shadow-2xl relative">
                <Header />
                {loading && (
                    <div className="absolute top-0 left-0 right-0 bottom-0 bg-black opacity-60 flex items-center justify-center z-50">
                        <img src='/logo192.png' alt="Loading..." className="w-10 h-10" />
                    </div>
                )}
                {showNotification && (
                    <div className="px-4 fixed bottom-[50px] w-full max-w-[600px] transform mb-8 animate-fade-in animate-slide-up z-50">
                        <div className="bg-stone-900 text-white w-full rounded p-4 text-sm font-semibold flex justify-between">
                            {error}
                            <span className="text-primary cursor-pointer" onClick={() => setShowNotification(false)}>Ok</span>
                        </div>
                    </div>
                )}
                <div className='pt-3 pb-[96px]'>
                    <div className='bg-white'>
                        <div className='px-4 pt-4 pb-2 md:p-4 flex justify-between items-center border-b-4 border-slate-100'>
                            <div className='flex items-center'>
                                <span className="mr-2">
                                    <BiWallet className='h-[16x] w-[16px] md:h-[18px] md:w-[18px]' />
                                </span>
                                <h1 className='font-semibold text-base md:text-lg'>Wallet List</h1>
                            </div>
                            <div className='text-primary md:font-semibold font-bold text-sm md:text-base'>
                                Pelajari
                            </div>
                        </div>
                        <div className='p-4'>
                            <div className='flex justify-between pb-4 items-center'>
                                <div className='md:block hidden'>
                                    <NavLink to='/wallet/add'>
                                        <button className='text-white flex items-center px-4 py-2 bg-sky-600 rounded-md border border-sky-500 text-sm font-medium'>
                                            <span className='mr-2'>
                                                <MdOutlineLibraryAdd size='20' />
                                            </span>
                                            <span>Tambah Wallet</span>
                                        </button>
                                    </NavLink>
                                </div>
                                <div className='ml-auto'>
                                    <SearchField
                                        placeholder="Search..."
                                        onChange={(value) => {
                                            setSearchQuery(value);
                                            setCurrentPage(0);
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="overflow-x-auto">
                                <table className='w-full items-center text-left table-auto'>
                                    <thead className='font-medium text-sm text-zinc-600 border-b border-t'>
                                        <tr>
                                            <th className='py-2 px-3 w-1/12'>No.</th>
                                            <th className='py-2 px-3'>Wallet</th>
                                            <th className='py-2 px-3 w-1/12'>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className='font-normal text-sm text-zinc-600 border-b'>
                                        {itemsToShow.map((item, index) => (
                                            <tr key={item.id} className='hover:bg-gray-200 items-start'>
                                                <td className='py-2 px-3 w-1/12 align-top'>{startIndex + index + 1}</td>
                                                <td className='py-2 px-3'>
                                                    {apakahPC === true ? (
                                                        <>

                                                            <span title={item.address}>
                                                                {item.label !== "" && item.chain !== "" && item.address.length > limit ? (
                                                                    item.address.slice(0, 30) + '...' + item.address.slice(-5)
                                                                ) : (
                                                                    item.address.length > 52 ?
                                                                        item.address.slice(0, 30) + '...' + item.address.slice(-5) :
                                                                        item.address
                                                                )}
                                                            </span>
                                                            {item.label !== "" ? (
                                                                <span className='ml-1 mr-1 box-decoration-slice bg-gradient-to-r from-cyan-500 to-primary text-white px-2 font-semibold' title={item.label}>
                                                                    {item.label.length > limitLabel ? (
                                                                        item.label.slice(0, limitLabel) + '...'
                                                                    ) : (
                                                                        item.label
                                                                    )}
                                                                </span>
                                                            ) : null}

                                                            {item.chain !== "" ? (
                                                                <span className='font-semibold'>(
                                                                    {item.chain.length > limitChain ? (
                                                                        item.chain.slice(0, limitChain) + '...'
                                                                    ) : (
                                                                        item.chain
                                                                    )}

                                                                    )</span>
                                                            ) : null}
                                                        </>
                                                    ) : <>
                                                        {item.label !== "" ? (
                                                            <span className='mr-1 box-decoration-slice bg-gradient-to-r from-cyan-500 to-primary text-white px-2 font-semibold' title={item.label}>
                                                                {item.label.length > limitLabel ? (
                                                                    item.label.slice(0, limitLabel) + '...'
                                                                ) : (
                                                                    item.label
                                                                )}
                                                            </span>
                                                        ) : null}
                                                        {item.chain !== "" ? (
                                                            <span className='font-bold'>(
                                                                {item.chain.length > limitChain ? (
                                                                    item.chain.slice(0, limitChain) + '...'
                                                                ) : (
                                                                    item.chain
                                                                )}

                                                                )</span>
                                                        ) : null}
                                                        <div>
                                                            <span title={item.address}>
                                                                {item.address.length > limit ? (
                                                                    item.address.slice(0, 20) + '...' + item.address.slice(-5)
                                                                ) : (
                                                                    item.address
                                                                )}
                                                            </span>
                                                        </div>
                                                    </>
                                                    }
                                                </td>
                                                <td className='py-2 px-3  w-1/12'>
                                                    <div className='flex justify-start'>
                                                        <button
                                                            className='mr-1'>
                                                            <FaEdit size='16px' className='text-green-500' />
                                                        </button>
                                                        <button onClick={() => hapusWallet(item.added)}
                                                            className='ml-1'>
                                                            <FaTrash size='16px' className='text-red-600' />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <div className='text-sm text-zinc-600 mt-4'>
                                Showing {startIndex > 0 ? startIndex : 0} to {endIndex} of {filteredData.length} entries
                            </div>
                            <ReactPaginate
                                previousLabel={
                                    <span className="px-4 py-2">
                                        &lt;
                                    </span>
                                }
                                nextLabel={
                                    <span className="px-4 py-2">
                                        &gt;
                                    </span>
                                }
                                breakLabel='...'
                                pageCount={Math.ceil(filteredData.length / itemsPerPage)}
                                marginPagesDisplayed={1}
                                pageRangeDisplayed={2}
                                onPageChange={handlePageChange}
                                containerClassName={'flex justify-center mt-4 text-sm'}
                                activeClassName={'bg-primary text-white px-4 py-2 !important'}
                                pageClassName={'border border-gray-100 px-4 py-2'}
                                breakClassName={'border border-gray-100 px-4 py-2'}
                                previousClassName={'border border-gray-100 px-4 py-2'}
                                nextClassName={'border border-gray-100 px-4 py-2'}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div >
    )
}

export default Manage
